const hideOptsMixin = {
    created: function () {
        this.$bus.$on('global-hide-options', () => {
            const funs = ['outAreaMouseDown', 'hide', 'cancel', this.hideCallbackName];
            const result = funs.filter(v => v && this[v] && typeof this[v] === 'function');
            result.length && this[result[0]]();
        });
    },
    beforeDestroy: function () {
        this.$bus.$off('global-hide-options');
    }
};

export default hideOptsMixin;
